import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { UserTypeEnum } from '../../../enums/user-type.enum';
import { ICountry, IPhonePrefix } from '../../../interfaces/generic.interface';
import { IUser } from '../../../interfaces/user.interface';
import { UserModel } from '../../../models/user.model';
import { GlobalService } from '../../../services/global.service';
import { ProfileService } from '../../../services/profile.service';
import { StorageService } from '../../../services/storage.service';
import { CommonUtil } from '../../../utils/common.utils';
import { MustMatch } from '../../../validators/must-match.validator';
import countryData from '../../../jsons/countries.json';

@Component({
  selector: 'hadsup-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
  standalone: false,
})
export class EditProfileComponent implements OnInit, OnDestroy {
  public phoneMask: any;
  public numb: any;
  public userName: any;
  public userSurname: any;
  private subscriptions = new Subscription();
  public profileForm: FormGroup | any;
  public profileLoadingData = false;
  public userProfile!: IUser;
  public isCompany: boolean = false;
  public isCheckBrandSelection: boolean = false;
  public loadingData: boolean = false;
  public passwordLoadingData: boolean = false;
  public selectedSector: any;
  public selectedIndustry: any;
  public changePasswordForm: FormGroup;
  public countryList: ICountry[] = countryData;
  public phonePrefixList: IPhonePrefix[] = [];
  public submitted: boolean = false;
  public submittedPassword: boolean = false;
  public isNewPassword: boolean = false;
  public isConfirmPassword: boolean = false;
  public isOldPassword: boolean = false;
  public newPasswordType = 'password';
  public oldPasswordType = 'password';
  public confirmPasswordType = 'password';
  public isLoading: boolean = false;
  public selectedCountry: ICountry | any = {
    country: 'United Kingdom',
    calling_code: '+44',
  };
  public selectedPhonePrefix: IPhonePrefix | any = {
    description: 'United Kingdom +44',
    calling_code: '+44',
  };
  public selectedFile: File | null = null;
  public imagePreview: string | null = null;
  public companyLogo: string = './assets/images/hadsup-logo.svg';
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private profileService: ProfileService,
    private toaster: ToastrService,
    private util: CommonUtil,
    private storageService: StorageService,
    private globalService: GlobalService
  ) {
    this.phoneMask = this.util.phoneMask;
    this.initForm()
    this.changePasswordForm = fb.group(
      {
        password: new FormControl('', [Validators.required,Validators.minLength(8)]),
        confirm_password: new FormControl('', [Validators.required]),
        old_password: new FormControl('', [Validators.required]),
      },
      {
        validator: MustMatch('password', 'confirm_password'),
      }
    );
    this.getPhonePrefixList();
  }

  ngOnInit(): void {
    this.getProfileDetails();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  initForm() {
    this.profileForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      user_name: ['', [Validators.required]],
      user_surname: [''],
      phone: [''],
      address: [''],
      town: [''],
      postcode: [''],
      address_country: [''],
      street: [''],
      profile_photo: new FormControl('')
    });
  }
  getPhonePrefixList() {
    this.countryList.forEach((item) => {
      this.phonePrefixList.push({
        description: item.country + ' ' + item.calling_code,
        calling_code: item.calling_code,
      });
    });
  }

  PrefixSelection(event: any) {
    this.selectedPhonePrefix = event;
  }

  CountrySelection(event: any) {
    this.selectedCountry = event;
  }

  getProfileDetails() {
    this.profileLoadingData = true;
    this.subscriptions.add(
      this.profileService.GetCompanyLogo().subscribe((response: any) => {
        if (response) {
          const data = response.data;
          if (data.relations && data.relations.companyLogo && data.relations.companyLogo.length > 0) {
            this.companyLogo = data.relations.companyLogo[0].url;
          }
          this.userProfile = response.data;
          if (
            this.userProfile.relations.roles.findIndex(
              (f) => f.id == UserTypeEnum.Sales
            ) > -1
          ) {
            this.isCheckBrandSelection = true;
          }
          this.storageService.setProfileInfo(this.userProfile);
          this.setFormValues();
          const role = this.userProfile.relations.balance.balance_user_role;
          if ( role == UserTypeEnum.LocationOwner ) {
            this.isCompany = true;
            this.toggleControlsValidation('company_name', true);
            this.toggleControlsValidation('company_number', true);
          } else {
            this.isCompany = false;
          }
        }
        this.profileLoadingData = false;
      })
    );
  }

  setFormValues() {
    if (this.userProfile) {
      this.profileForm.controls['email'].setValue(this.userProfile.email);
      this.profileForm.controls['user_name'].setValue(
        this.userProfile.user_name
      );
      this.profileForm.controls['user_surname'].setValue(
        this.userProfile.user_surname
      );

      if (this.userProfile.phone) {
        const fullPhone = this.userProfile.phone.split('_');
        if (fullPhone?.length == 2) {
          const selectedPhonePrefix = this.phonePrefixList.find(
            (f) => f.calling_code == fullPhone[0]
          );
          if (selectedPhonePrefix) {
            this.selectedPhonePrefix = selectedPhonePrefix;
          }
          this.profileForm.controls['phone'].setValue(fullPhone[1]);
        } else
          this.profileForm.controls['phone'].setValue(this.userProfile.phone);
      }

      this.profileForm.controls['street'].setValue(this.userProfile.street);
      this.profileForm.controls['town'].setValue(this.userProfile.town);
      this.profileForm.controls['postcode'].setValue(this.userProfile.postcode);
      this.profileForm.controls['address_country'].setValue(
        this.userProfile.address_country
      );
      this.profileForm.controls['profile_photo'].setValue(
        this.userProfile.profile_photo
      );
      this.profileForm.controls['address'].setValue(
        this.userProfile.address
      );
      const selectedCountry = this.countryList.find(
        (f) => f.country == this.userProfile.address_country
      );
      if (selectedCountry) {
        this.selectedCountry = selectedCountry;
      }
    }
  }

  toggleControlsValidation(controlName: string, status: boolean) {
    if (!status) {
      this.profileForm.controls[controlName].clearValidators();
      this.profileForm.controls[controlName].updateValueAndValidity();
    } else {
      this.profileForm.controls[controlName].setValidators([
        Validators.required,
      ]);
      this.profileForm.controls[controlName].updateValueAndValidity();
    }
  }

  updateProfile() {
    this.submitted = true;
    if (this.profileForm.invalid) return false;
    if (this.profileForm.valid && this.profileForm.dirty) {
      this.loadingData = true;
      const submittedForm = { ...this.profileForm.value } as UserModel;
      if (submittedForm.phone) {
        this.numb = submittedForm.phone.match(/\d/g);
        const phone = this.numb.join('');
        submittedForm.phone =
          this.selectedPhonePrefix.calling_code + '_' + phone;
      }
      if (this.selectedCountry) {
        submittedForm.address_country = this.selectedCountry.country;
      }
      this.profileService.UpdateProfile(submittedForm).subscribe((response) => {
        if (response) {
          this.toaster.success('Profile updated successfully');
          this.router.navigate(['profile'], {
            relativeTo: this.route.parent,
          });
          this.loadingData = false;
          this.profileForm.markAsPristine();
        }
      });
    }
    return;
  }



  discardChanges() {
    this.router.navigate(['profile'], { relativeTo: this.route.parent });
  }

  /**
   * Fetch the Selector option after select the industry
   * @param id
   */

  hideShow(type: string) {
    if (type === 'NEW') {
      this.isNewPassword = !this.isNewPassword;
      this.newPasswordType = this.isNewPassword ? 'text' : 'password';
    }
    if (type === 'OLD') {
      this.isOldPassword = !this.isOldPassword;
      this.oldPasswordType = this.isOldPassword ? 'text' : 'password';
    }
    if (type === 'CONFIRM') {
      this.isConfirmPassword = !this.isConfirmPassword;
      this.confirmPasswordType = this.isConfirmPassword ? 'text' : 'password';
    }
  }

  onFileUpload(event: any, isDropEvent = false) {
    let file: File;
    if (isDropEvent) {
      event.preventDefault();

      file = event.dataTransfer.files[0];

    } else {
      file = event.target.files[0];
    }
    if (file && this.isValidFileType(file)) {
      this.selectedFile = file;
      this.headerLogoUpload(file)
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  headerLogoUpload(file: any) {
    const formData = new FormData();
    formData.append('file', file);
    this.profileService.headerLogo(formData).subscribe({
      next: (data: any) => {
        if (data && data.body) {
          this.globalService.updateLogo(data.body.data.url);
        }
      },
      error: (err) => {
        console.error('Error uploading logo:', err);
      }
    });
  }

  onDragOver(event: any) {
    event.preventDefault();
  }

  isValidFileType(file: File): boolean {
    const validTypes = ['image/png', 'image/jpeg', 'image/gif', 'image/svg+xml'];
    const maxFileSize = 5000000;
    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      const isValidSize = img.width <= 800 && img.height <= 400;
      return validTypes.includes(file.type) && isValidSize && file.size <= maxFileSize;
    };
    return validTypes.includes(file.type) && file.size <= maxFileSize;
  }


  passwordHideShow(type: string) {
    if (type === 'NEW') {
      this.isNewPassword = !this.isNewPassword;
      this.newPasswordType = this.isNewPassword ? 'text' : 'password';
    }
    if (type === 'OLD') {
      this.isOldPassword = !this.isOldPassword;
      this.oldPasswordType = this.isOldPassword ? 'text' : 'password';
    }
    if (type === 'CONFIRM') {
      this.isConfirmPassword = !this.isConfirmPassword;
      this.confirmPasswordType = this.isConfirmPassword
        ? 'text'
        : 'password';
    }
  }
  updatePassword() {
    if (this.isLoading) {
      this.submittedPassword = false;
      return;
    }

    this.submittedPassword = true;

    if (this.changePasswordForm.valid) {
      this.isLoading = true;
      const submittedForm = this.changePasswordForm.value;

      this.profileService.UpdatePassword(submittedForm)
        .subscribe({
          next: (response: any) => {
            if (response && response.success) {
              this.toaster.success('Password changed successfully', 'Success');
              this.submittedPassword = false;
              this.isLoading = false;
              this.changePasswordForm.reset();
            }
          },
          error: (error: any) => {
            this.toaster.error(error.error.errors[0].errors, 'Error');
            this.submittedPassword = false;
            this.isLoading = false;
          },
          complete: () => {
            this.submittedPassword = false;
            this.isLoading = false;
          }
        });
    }
  }

  get f() {
    return this.changePasswordForm.controls;
  }
  setGeoposition(event: any): void {
    const location = event.geometry.location;

    let town = '';
    let postcode = '';
    let country = '';

    event.address_components.forEach((component: any) => {
        if (component.types.includes('locality')) {
            town = component.long_name; 
        }
        if (component.types.includes('postal_code')) {
            postcode = component.long_name; 
        }
        if (component.types.includes('country')) {
            country = component.long_name; 
        }
    });

    this.profileForm.patchValue({
        address: event.formatted_address,
        town: town,
        postcode: postcode,
        address_country: country,
        google_place_id: event.place_id,
        geo_point: [location.lat(), location.lng()]
    });
}
  isNumber(event: KeyboardEvent) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
        event.preventDefault();
    }
  }
}
